export const datepicker = {
  root: {},
  panel: {
    background: 'rgb(255, 255, 255)',
    borderColor: 'rgb(226, 232, 240)',
    borderRadius: '1rem',
    color: 'rgb(31, 41, 55)',
    shadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  },
  css: ({ dt }: any) => `
    .p-datepicker-select-month,
    .p-datepicker-select-year,
    .p-datepicker-weekday,
    .p-datepicker-day {
      font-size: 0.875rem;
      }

    .p-datepicker-select-month,
    .p-datepicker-select-year {
      text-transform: capitalize;
    }
      
    .p-datepicker-weekday {
      text-transform: uppercase;
    }

    @media (max-width: 600px) {
      .p-datepicker-input {
        letter-spacing: -0.025em;
      }
    }
  `,
};
